import dialogPage from 'BASE/store/chat/chat.store.model.dialogPage';

export default class {
    constructor() {
        this.isConnected = false;
        this.isAnonymity = false;
        this.reconnectedSyncTime = null;
        this.userId = "";
        this.loginId = "";
        this.nickName = "";
        this.userLevel = 0;
        this.headImage = "";
        this.customerServiceRating = {
            sessionId: "",
            isAlreadyRating: false
        };
        // 判斷是否正在群發下級
        this.isMulticasting = false;
        // 判斷是否客服使用外接聊天室
        this.hasChatExternalLink = false;
        // 判斷禁聊下級是否包含
        this.excludeIsChatDenied = false;
        // 是否為全站群聊導師
        this.isSiteGroupTutor = false;
        
        // 切換dialog頁面使用
        // 因為手機版聊天室會跨組件切換頁面與子組件間傳遞資料, 因此用store存取
        this.dialogPage = new dialogPage();
        
        this.rooms = [];
        this.roomListClassifications = [];
        this.roomWindows = [];
        this.roomMessageContainers = [];
        this.roomMemberContainers = [];
        this.roomWindowSizes = [];
        
        // 全站群聊
        this.siteGroupRoom = null;
        // 導師列表
        this.tutors = [];
        // 通知彈窗的導師訊息房間 id
        this.tutorMessageNoticeRoomId = null;

        // 在頁面上不能被改, 只能read only, 因為updateLastMessage會Object.freeze陣列內的每個物件
        this.roomLastMessages = [];
    }
}
